module.exports = __webpack_public_path__ + "img/watermark.b77b53a4.png";